import BasicLayout from "./BasicLayout";
import Divider from "components/Divider";
import { formatPrice } from "utils/price";
import axiosClient from "axios-client.js";
import { useEffect, useState } from "react";
import ModalHorizon from "components/modal";
import PlusIcon from "components/icons/PlusIcon";
import EasyListBox from "components/EasyListBox";
import TrashIcon from "components/icons/TrashIcon";
import CicleInfoIcon from "components/icons/CicleInfoIcon";
import { activeMaintenanceValue } from "utils/maintenance";
import CicleExclamationIcon from "components/icons/CicleExclamationIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/MyTooltip";

const Step3 = ({ activationType, state, setState, setLoad, setMessage }) => {
    const [modal, setModal] = useState({
        active: false,
        title: null,
        description: null,
        btnVisible: false,
        onClickBtn: null,
        btnLabel: null,
    });
    useEffect(() => {
        var licensesState = [];
        state.data.licenses.forEach((license, idx) => {
            licensesState[idx] = {
                code: license.code,
                qty: license.qty ? license.qty : 0,
                active: license.active,
            };
        });
        if (licensesState.length === 0) {
            licensesState = [
                {
                    code: "default",
                    qty: 0,
                    active: false,
                },
            ];
        }

        axiosClient
            .get(`/activation/${state.code}/licenses`, {
                params: {
                    server_type: state.type,
                    data: {
                        licenses: licensesState,
                        maintenance: {
                            qty: state?.data?.maintenance
                                ? state?.data?.maintenance
                                : 0,
                        },
                    },
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setState((state) => ({
                    ...state,
                    data: {
                        ...state.data,
                        licenses: Object.keys(data?.data?.licenses)
                            .map((lic) => {
                                if (
                                    data?.data?.licenses?.[lic]?.mode ===
                                        "select" &&
                                    data.data.licenses[lic].qty === 0 &&
                                    data.data.licenses[lic].active === false
                                ) {
                                    data.data.licenses[lic].qty =
                                        Object.values(
                                            data?.data?.licenses?.[lic]?.values
                                        )?.[0] || "";
                                }
                                return data?.data?.licenses[lic];
                            })
                            .sort((a, b) => (a.order > b.order ? 1 : -1)),
                        maintenance: activeMaintenanceValue(
                            data?.data?.maintenance
                                ? data?.data?.maintenance
                                : 0
                        ),
                        maintenance_data: data?.data?.maintenance,
                        maintenance_skip: data?.data?.skip_maintenance,
                    },
                }));
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }, []);

    function selectLicense(index) {
        var licensesState = [];
        state.data.licenses.forEach((license, idx) => {
            licensesState[idx] = {
                code: license.code,
                qty:
                    idx === index
                        ? license.qty
                            ? license.qty
                            : 1
                        : license.qty
                        ? license.qty
                        : 0,
                active: idx === index ? true : license.active,
            };
        });

        axiosClient
            .get(`/activation/${state.code}/licenses`, {
                params: {
                    server_type: state.type,
                    data: {
                        licenses: licensesState,
                        maintenance: {
                            qty: state?.data?.maintenance
                                ? state?.data?.maintenance
                                : 0,
                        },
                    },
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setState((state) => ({
                    ...state,
                    data: {
                        ...state.data,
                        licenses: Object.keys(data?.data?.licenses)
                            .map((lic) => {
                                return data?.data?.licenses[lic];
                            })
                            .sort((a, b) => (a.order > b.order ? 1 : -1)),
                        maintenance: activeMaintenanceValue(
                            data?.data?.maintenance
                                ? data?.data?.maintenance
                                : 0
                        ),
                        maintenance_data: data?.data?.maintenance,
                        maintenance_skip: data?.data?.skip_maintenance,
                        total: data?.data?.total,
                    },
                }));
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }

    function updateLicenseAmount(index, value, activate = false) {
        var licensesState = [];
        state.data.licenses.forEach((license, idx) => {
            licensesState[idx] = {
                code: license.code,
                qty: idx === index ? value : license.qty ? license.qty : 0,
                active: idx === index && activate ? true : license.active,
            };
        });

        axiosClient
            .get(`/activation/${state.code}/licenses`, {
                params: {
                    server_type: state.type,
                    data: {
                        licenses: licensesState,
                        maintenance: {
                            qty: state?.data?.maintenance
                                ? state?.data?.maintenance
                                : 0,
                        },
                    },
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setState((state) => ({
                    ...state,
                    data: {
                        ...state.data,
                        licenses: Object.keys(data?.data?.licenses)
                            .map((lic) => {
                                return data?.data?.licenses[lic];
                            })
                            .sort((a, b) => (a.order > b.order ? 1 : -1)),
                        maintenance: activeMaintenanceValue(
                            data?.data?.maintenance
                                ? data?.data?.maintenance
                                : 0
                        ),
                        maintenance_data: data?.data?.maintenance,
                        total: data?.data?.total,
                    },
                }));
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }

    function openInfoModal(index) {
        var license = state.data.licenses[index];
        setModal((previousState) => {
            return {
                ...previousState,
                active: true,
                title: license.name,
                description: license.tooltip,
            };
        });
    }

    function closeModal() {
        setModal((previousState) => {
            return {
                ...previousState,
                active: false,
                title: null,
                description: null,
                btnVisible: null,
                onClickBtn: null,
                btnLabel: null,
            };
        });
    }

    function removeLicense(index) {
        var licensesState = [];
        state.data.licenses.forEach((license, idx) => {
            licensesState[idx] = {
                code: license.code,
                qty:
                    idx === index
                        ? license.mode === "select"
                            ? Object.values(license.values)?.at(0)
                            : 0
                        : license.qty
                        ? license.qty
                        : 0,
                active: idx === index ? false : license.active,
            };
        });

        axiosClient
            .get(`/activation/${state.code}/licenses`, {
                params: {
                    server_type: state.type,
                    data: {
                        licenses: licensesState,
                        maintenance: {
                            qty: state?.data?.maintenance
                                ? state?.data?.maintenance
                                : 0,
                        },
                    },
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setState((state) => ({
                    ...state,
                    data: {
                        ...state.data,
                        licenses: Object.keys(data?.data?.licenses)
                            .map((lic) => {
                                return data?.data?.licenses[lic];
                            })
                            .sort((a, b) => (a.order > b.order ? 1 : -1)),
                        maintenance: activeMaintenanceValue(
                            data?.data?.maintenance
                                ? data?.data?.maintenance
                                : 0
                        ),
                        maintenance_data: data?.data?.maintenance,
                        maintenance_skip: data?.data?.skip_maintenance,
                        total: data?.data?.total,
                    },
                }));
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }

    const handleChange = (event, index) => {
        const value = event.target.value;

        var licensesState = state.data.licenses;
        licensesState[index]["qty"] = value;

        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                licenses: licensesState,
            },
        }));
    };

    return (
        <BasicLayout
            title="Licenze"
            subtitle={
                <>
                    Scegli le licenze necessarie alla configurazione della tua
                    piattaforma Proxima{" "}
                    <span className="capitalize">{activationType}</span>.
                    <br />
                    <br />
                    Posizionati sui box rettangolari per inserire la quantità di
                    licenze da acquistare: il configuratore calcolerà il costo
                    totale delle licenze.
                    <br />
                    Se vuoi modificare la quantità inserita: clicca sul cestino,
                    aggiorna il numero di licenze e poi clicca sul bottone “+”
                    per aggiornare il totale.
                    <br />
                    <br />
                    <strong>N.B. I prezzi mostrati sono iva esclusa.</strong>
                </>
            }
            content={
                <>
                    <ModalHorizon
                        title={modal.title}
                        description={modal.description}
                        isOpen={modal.active}
                        onClose={closeModal}
                        btnVisible={modal.btnVisible}
                        onClickBtn={modal.onClickBtn}
                        btnLabel={modal.btnLabel}
                    />

                    {state?.data?.licenses?.map((license, index) => {
                        return (
                            <div
                                key={license.code}
                                className="!z-5 mt-6 grid grid-cols-1 gap-2 rounded-[8px] bg-white bg-clip-border p-4 font-medium text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:grid-cols-5"
                            >
                                <div className="col-span-3 flex items-center gap-4">
                                    <p className="shrink-0">{license.name}</p>

                                    <div
                                        className="flex-1 cursor-pointer self-center text-gray-600"
                                        onClick={() => openInfoModal(index)}
                                    >
                                        <CicleInfoIcon />
                                    </div>
                                </div>

                                <div>
                                    {license.mode === "select" ? (
                                        <div className="mx-2 shrink-0">
                                            <EasyListBox
                                                data={Object.values(
                                                    license?.values
                                                )?.map((value) => ({
                                                    value: value,
                                                    label: value.toString(),
                                                }))}
                                                handleSelection={(value) => {
                                                    updateLicenseAmount(
                                                        index,
                                                        value
                                                    );
                                                }}
                                                selected={license.qty}
                                            />
                                        </div>
                                    ) : license.mode === "qty" ? (
                                        <div
                                            className={`-mx-2 flex items-stretch`}
                                        >
                                            <Tooltip>
                                                <TooltipTrigger>
                                                    <label
                                                        htmlFor="qty"
                                                        className={`mx-2 shrink-0 self-center text-sm font-medium text-gray-700 dark:text-white`}
                                                    >
                                                        q.tà
                                                    </label>
                                                </TooltipTrigger>

                                                <TooltipContent>
                                                    <div className="-mx-2 flex items-stretch">
                                                        <div className="mx-2 shrink-0 self-center text-amber-500">
                                                            <CicleExclamationIcon />
                                                        </div>
                                                        <p className="mx-2 flex-1 dark:text-white">
                                                            Per modificare la
                                                            quantità selezionata
                                                            clicca sull’icona
                                                            del cestino e
                                                            resetta la tua
                                                            scelta.
                                                        </p>
                                                    </div>
                                                </TooltipContent>
                                            </Tooltip>

                                            <input
                                                disabled={license.active}
                                                type="number"
                                                name={"qty"}
                                                value={license.qty}
                                                min={"0"}
                                                max={"99999"}
                                                onChange={(e) => {
                                                    if (e.target.value >= 0) {
                                                        handleChange(e, index);
                                                    }
                                                }}
                                                placeholder={"0"}
                                                className={`mx-2 flex h-8 w-full flex-1 items-center justify-center rounded-[8px] border bg-white/0 p-3 text-xs outline-none ${
                                                    license.active
                                                        ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                                                        : state === "error"
                                                        ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                                                        : state === "success"
                                                        ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                                                        : "border-gray-200 dark:!border-white/10 dark:text-white"
                                                }`}
                                            />
                                        </div>
                                    ) : null}
                                </div>

                                <div className="flex h-full flex-row self-center">
                                    {license.mode === "qty" && (
                                        <Divider isVertical className="mx-2" />
                                    )}

                                    <div className="mx-2 flex-1 self-center">
                                        <p className="m-0 font-bold">
                                            {license.code !== "cluster"
                                                ? license.mode === "select" ||
                                                  license.active
                                                    ? "€ " +
                                                      formatPrice(license.price)
                                                    : "--,--"
                                                : "+ " +
                                                  parseFloat(license.price) *
                                                      100 +
                                                  "%"}
                                        </p>
                                    </div>

                                    <div className="mx-2 shrink-0 self-center">
                                        {license.active ? (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    removeLicense(index)
                                                }
                                                className="linear flex h-[30px] w-[30px] items-center justify-center rounded-full bg-blue-500 text-center text-xl font-bold uppercase text-white transition duration-200 hover:bg-blue-300 active:bg-blue-700 dark:bg-blue-400 dark:text-white dark:hover:bg-blue-300 dark:active:bg-blue-200"
                                            >
                                                <TrashIcon />
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (
                                                        license.mode ===
                                                        "select"
                                                    ) {
                                                        updateLicenseAmount(
                                                            index,
                                                            license.qty,
                                                            true
                                                        );
                                                    } else {
                                                        selectLicense(index);
                                                    }
                                                }}
                                                disabled={
                                                    (!license.qty ||
                                                        license.qty === "0" ||
                                                        license.qty === 0) &&
                                                    license.mode === "qty"
                                                }
                                                style={{
                                                    opacity:
                                                        (license.qty &&
                                                            license.qty !==
                                                                "0" &&
                                                            license.qty !==
                                                                0) ||
                                                        license.mode !== "qty"
                                                            ? 1
                                                            : 0.5,
                                                }}
                                                className="linear flex h-[30px] w-[30px] items-center justify-center rounded-full bg-brand-500 text-center text-xl font-bold uppercase text-white transition duration-200 hover:bg-brand-300 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                                            >
                                                <PlusIcon />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            }
        />
    );
};

export default Step3;
